<template>
  <div>
    <!-- Menu -->
    <v-card class="rounded-lg">
      <v-card-title>
        Menu

        <v-spacer></v-spacer>

        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          max-width="90%"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              color="botao_1"
              append-icon="mdi-filter"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            color="botao_2"
            type="month"
            no-title
            scrollable
            locale="pt-br"
          >
            <v-spacer></v-spacer>

            <v-btn
              text
              @click="menu=false"
            >Cancelar</v-btn>
            
            <v-btn
              text
              @click="$refs.menu.save(date)"
            >OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-spacer></v-spacer>

        <v-dialog transition="dialog-top-transition" max-width="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="botao_1"
              class="rounded-lg"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Adicionar Entrada/Saida
            </v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card class="rounded-lg">
              <v-toolbar dark class="rounded-lg" color="primary">
                Adicionar
              </v-toolbar>

              <v-card-text>
                <v-form ref="form">
                  <!-- Descrição -->
                  <v-text-field
                    v-model.trim="form.descricao"
                    :counter="maximo_caracteres"
                    :maxlength="maximo_caracteres"
                    label="Descrição"
                    :rules="[
                      () => !!form.descricao || 'A descrição é obrigatória',
                      () =>
                        form.descricao.length <= 100 ||
                        'A descrição deve conter no máximo 100 caracteres',
                    ]"
                    required
                  ></v-text-field>

                  <!-- Data -->
                  <v-text-field
                    v-model.trim="form.data"
                    type="month"
                    label="Data"
                    :rules="[(v) => !!v || 'A data é obrigatória']"
                    required
                  ></v-text-field>

                  <!-- Tipo -->
                  <v-select
                    v-model.trim="form.tipo"
                    :items="tipos"
                    label="Tipo"
                    :rules="[(v) => !!v || 'O tipo é obrigatório']"
                    required
                  ></v-select>

                  <!-- Valor Total -->
                  <v-currency-field
                    v-model.trim="form.valor_total"
                    type="number"
                    label="Valor Total"
                    :rules="[(v) => !!v || 'O valor total é obrigatório']"
                    v-bind="currency_config"
                    :error-messages="errors.price"
                    required
                  ></v-currency-field>

                  <!-- Quantidade de Parcelas -->
                  <v-text-field
                    v-model.trim="form.num_parcelas"
                    type="number"
                    label="Quantidade de Parcelas"
                    :rules="[
                      (v) => !!v || 'A quantidade de parcelas é obrigatória',
                      (v) =>
                        v > 0 ||
                        'O numeros de parcelas deve ser maior do que 0',
                    ]"
                    required
                  ></v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false"> Cancelar </v-btn>
                <v-btn text @click="salvar(dialog)"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-card-title>
    </v-card>

    <br />

    <!-- Painel Valores -->
    <PainelValoresComp />
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import PainelValoresComp from "./PainelValoresComp";

export default {
  components: {
    PainelValoresComp,
  },

  data: () => ({
    menu: false,
    dialog: false,
    date: new Date().toISOString().substr(0, 7),
    tipos: ["entrada", "saida"],
    form: {
      descricao: "",
      data: new Date().toISOString().substr(0, 7),
      num_parcelas: 1,
    },
    maximo_caracteres: 100,
    errors: {},
    currency_config: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false,
      allowBlank: false,
      min: Number.MIN_SAFE_INTEGER,
      max: Number.MAX_SAFE_INTEGER,
    },
  }),

  methods: {
    ...mapActions(["dividasAnoMesAction", "adicionarAction"]),

    ...mapMutations(["CarregandoMutation"]),

    salvar(dialog) {
      if (this.$refs.form.validate()) {
        this.adicionarAction(this.form);

        (this.form = {
          descricao: "",
          data: new Date().toISOString().substr(0, 7),
          num_parcelas: 1,
        }),
          (dialog.value = false);
      }
    },

    dividas_ano_mes() {
      this.dividasAnoMesAction(this.date);
      this.$store.state.date_state = this.date;
    },
  },

  mounted() {
    this.dividas_ano_mes();
  },

  watch: {
    date: function () {
      this.dividas_ano_mes();
    },
  },
};
</script>
